export const PublicImagePath='https://storage.thebloxoffice.com/images/large/events/'
export const AWSAlternative='https://event-rickrosstickets-s3-prod.s3.us-west-2.amazonaws.com/'
export const AWSAlternativeOld='https://elasticbeanstalk-us-east-2-641171614455.s3.amazonaws.com/'
